<template>
  <div
    class="chat"
    :class="{'chat-left': !message.is_staff}"
  >
    <div class="chat-avatar d-flex flex-column">
      <b-avatar
        size="36"
        class="avatar-border-2 box-shadow-1"
        variant="transparent"
        :src="message.user.avatar"
      />
    </div>
    <div class="chat-body">
      <div
        class="chat-content w-100"
      >
        <p class="mb-3 font-weight-bold">
          {{ message.user.name }}
        </p>
        <p
          class="text-break"
          v-html="message.content"
        />
        <p
          class="d-flex justify-content-start"
          style="direction: ltr"
        >
          {{ message.created_at | localeDateTime }}
        </p>
        <div
          v-if="message.attachments && message.attachments.length"
          class="mail-attachments"
        >
          <div class="d-flex align-items-center mb-1">
            <feather-icon
              icon="PaperclipIcon"
              size="16"
            />
            <h5 class="font-weight-bolder text-body mb-0 ml-50">
              {{ $t('Attachments') }}
            </h5>
          </div>

          <div class="d-flex flex-column">
            <b-link
              v-for="(attachment, index) in message.attachments"
              :key="index"
              :href="attachment.url"
              target="_blank"
              :class="{'mt-75': index}"
            >
              <b-img
                :src="attachment.url"
                width="16px"
                class="mr-50"
              />
              <span class="text-muted font-weight-bolder align-text-top">{{ attachment.name }}</span>
              <span class="text-muted font-small-2 ml-25">({{ attachment.size | humanFileSize }})</span>
            </b-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BLink, BImg } from 'bootstrap-vue'

export default {
  name: 'TicketMessage',
  components: {
    BAvatar,
    BLink,
    BImg,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>

</style>
